import Vue from 'vue'
import bookPageAudio from '@/services/bookPageAudio'
import EncryptDecrypt from '../utils/encrypt-decrypt'

const SpeechSynthesis = Vue.extend({
    methods: {
        speech(text = "") {
            const synthesis = window.speechSynthesis;
            if (!synthesis) {
                console.debug('speechSynthesis is not available')
                return
            }

            const voices = synthesis.getVoices();
            const voice = voices.filter(v => v.default);

            if (voice) {
                const utterThis = new SpeechSynthesisUtterance();
                utterThis.text = text;
                utterThis.lang = 'es';
                utterThis.rate = 0.8;
                utterThis.volume = 0.4;
                synthesis.speak(utterThis);
            }
        },
        readText(text: string){
            const encryptedText = EncryptDecrypt.encodeBase64UrlSafe(text)
            const audio = new Audio(`${process.env.VUE_APP_QUESTION_ANSWER_READER}${encryptedText}.mp3`);
            
            audio.playbackRate = 0.9;
            audio.volume = 0.4;

            audio.play()
            .catch(() => {
                console.log('audioo not found')
                this.generateQuestionAudio(encryptedText)
                this.speech(text)
            });

        },
        async generateQuestionAudio(encryptedText:string){
            try {
                await bookPageAudio.generateQuestionAudio(encryptedText)
            } catch (error) {
                console.error(error)
            }
        },
        stopAndRemoveText() {
            const synthesis = window.speechSynthesis;
            synthesis.cancel();
        }
    },
});

export default SpeechSynthesis
